<template>
    <BaseCard as="button" type="button" padding="none" class="overflow-hidden text-left" @click="emit('select')">
        <div class="relative">
            <img :src="video.poster" alt="" class="aspect-video w-full object-cover" />
            <span class="absolute inset-0 flex items-center justify-center">
                <span class="flex h-11 w-11 items-center justify-center rounded-full bg-surface-raised text-ink shadow-card">
                    <i class="bi bi-play-fill text-xl" aria-hidden="true"></i>
                </span>
            </span>
            <span class="absolute right-2 bottom-2 rounded-md bg-ink px-2 py-1 text-xs text-ink-inverse">{{ formatDuration(video.durationSeconds) }}</span>
        </div>
        <div class="flex flex-col gap-1 p-4">
            <p class="body-semibold text-ink">{{ video.title }}</p>
            <p class="body-small text-ink-muted">{{ video.feature }}</p>
        </div>
    </BaseCard>
</template>

<script setup lang="ts">
import BaseCard from "~vue/components/BaseCard.vue";

import { formatDuration, type WalkthroughVideo } from "./walkthroughVideos";

defineProps<{ video: WalkthroughVideo }>();
const emit = defineEmits<{ select: [] }>();
</script>
